import "polyfills/String​.prototype​.ends​With";

export const getOrigin = () => {
  const origin = window.location.origin;
  if (origin.endsWith("/")) return origin.substring(origin, origin.length - 1);
  return origin;
};

export const origin = getOrigin();
